import { Datepicker } from 'vanillajs-datepicker';
// eslint-disable-next-line import/no-unresolved
import ru from 'vanillajs-datepicker/locales/ru';
import axios from 'axios';

Object.assign(Datepicker.locales, ru);

export default async function AskForms() {
  // Валидация формы
  const isRequired = (value) => value !== '';

  const checkName = (activeForm) => {
    const nameInput = activeForm.querySelector('#fio');
    const formItem = nameInput.closest('.form-item');
    if (!isRequired(nameInput.value.trim())) {
      formItem.classList.add('err-item');
      return false;
    }
    formItem.classList.remove('err-item');
    return true;
  };

  const checkConvenientDate = (activeForm) => {
    const dateInput = activeForm.querySelector('#dateInput');
    if (!isRequired(dateInput.value.trim())) {
      dateInput.closest('.form-item').classList.add('err-item');
      return false;
    }
    dateInput.closest('.form-item').classList.remove('err-item');

    return true;
  };

  const checkEmailValid = (activeForm) => {
    const emailItem = activeForm.querySelector('#email');
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const isValidRes = re.test(emailItem.value.trim().replace(/\s/g, ''));
    if (!isValidRes) {
      emailItem.closest('.form-item').classList.add('err-item');
      return false;
    }
    emailItem.closest('.form-item').classList.remove('err-item');

    return true;
  };

  const checkPersonal = (activeForm) => {
    const personalCheck = activeForm.querySelector('[name="agreedBox"]');
    if (!personalCheck.checked) {
      personalCheck.closest('.form-checkbox').classList.add('err-box');
      return false;
    }
    personalCheck.closest('.form-checkbox').classList.remove('err-box');

    return true;
  };

  const checkAsk = (activeForm) => {
    const nameInput = activeForm.querySelector('#ask');
    const formItem = nameInput.closest('.form-item');
    if (!isRequired(nameInput.value.trim())) {
      formItem.classList.add('err-item');
      return false;
    }
    formItem.classList.remove('err-item');
    return true;
  };

  function isValid(activeForm) {
    const formName = checkName(activeForm);
    const convenient = checkConvenientDate(activeForm);
    const email = checkEmailValid(activeForm);
    const personalValid = checkPersonal(activeForm);
    const askValid = checkAsk(activeForm);

    return convenient && formName && email && personalValid && askValid;
  }

  /**
   * @param {HTMLElement} fileInputCont
   * @param {File} file
   */
  function updateThumbnail(fileInputCont, file) {
    const KByte = 1024;
    const MByte = 1024 * KByte;

    if (file.size > 5 * MByte) {
      document.getElementById('file-input-desc').classList.add('file-err');
      return;
    }

    document.getElementById('file-input-desc').classList.remove('file-err');

    fileInputCont.classList.add('is-upload');

    const fileDesc = fileInputCont.querySelector('.upload-file-desc .file-desc');
    const removeBtn = fileInputCont.querySelector('#remove-file');

    fileDesc.innerText = file.name;

    removeBtn.addEventListener('click', () => {
      const fileInput = fileInputCont.querySelector('[name="file"]');
      fileInput.value = '';

      if (fileInputCont.classList.contains('is-upload')) {
        fileInputCont.classList.remove('is-upload');
        fileDesc.innerText = 'Файл не выбран...';
      }
    });
  }

  const askFileInput = document.getElementById('askFile');

  if (askFileInput) {
    askFileInput.addEventListener('change', () => {
      if (askFileInput.files.length) {
        const askFileElement = askFileInput.closest('.file-input');

        updateThumbnail(askFileElement, askFileInput.files[0]);
      }
    });
  }

  // Отрисовка календаря для выбора даты рождения
  const birthDate = document.querySelectorAll('[data-inputType="birthYear"]');
  if (birthDate) {
    birthDate.forEach((elem) => {
      // eslint-disable-next-line no-new
      new Datepicker(elem, {
        format: 'yyyy',
        language: 'ru',
        autohide: true,
        startView: 2,
        pickLevel: 2,
        maxDate: getDateOffsetByFormatting(0),
      });
      elem.addEventListener('changeDate', (e) => {
        e.currentTarget.closest('.form-item').classList.remove('err-item');
      });
    });
  }

  /**
   * Получить сегодняшнюю дату в формате {дд-мм-гггг}
   * @var {int} offset
   * @returns {string}
   */
  function getDateOffsetByFormatting(offset = 1) {
    const date = new Date();
    // К месяцу добавить +1, из-за того что месяцы идут от 0 до 11.
    date.setDate(date.getDate() + offset);
    return `${date.getFullYear()}`;
  }

  const askSendBtn = document.querySelector('#ask-form-template .form-send');
  if (askSendBtn) {
    // eslint-disable-next-line no-restricted-syntax
    const activeForm = askSendBtn.closest('#ask-form-template');
    await sendAppointment(askSendBtn, activeForm);
  }

  // Срабатывает, когда происходит ввод данных в форме
  const debounce = (fn, delay = 100) => {
    let timeoutId;
    return (...args) => {
      // cancel the previous timer
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      // setup a new timer
      timeoutId = setTimeout(() => {
        fn.apply(null, args);
      }, delay);
    };
  };

  const tabForms = document.querySelectorAll('#ask-form-template input, #ask-form-template textarea');
  if (tabForms) {
    tabForms.forEach((tabForm) => {
      // Проверка на правильность заполнения полей при потере фокуса
      tabForm.addEventListener('blur', debounce((e) => {
        const actForm = e.target.closest('#ask-form-template');
        switch (e.target.id) {
          case 'fio':
            checkName(actForm);
            break;
          case 'email':
            checkEmailValid(actForm);
            break;
          case 'dateInput':
            checkConvenientDate(actForm);
            break;
          case 'ask':
            checkAsk(actForm);
            break;
          case 'personal':
            checkPersonal(actForm);
            break;
          default:
            break;
        }
      }));

      // Снятие выделения полей при вводе
      tabForm.addEventListener('focus', debounce(() => {
        const parentItem = tabForm.closest('.form-item');
        parentItem.classList.remove('err-item');
      }));
    });
  }

  /**
   * Отправка данных с формы ask.
   * @returns {Promise<void>}
   */
  async function sendAppointment(button, form) {
    /**
     * Отправка формы записи на приём
     * @param {Event} event
     */
    async function sendFn(event) {
      event.preventDefault();
      const token = document.querySelector('meta[name="csrf-token"]').content;

      if (isValid(form)) {
        try {
          button.disabled = true;
          button.innerText = 'Отправление';
          const file = document.getElementById('askFile').files[0];

          const formData = new FormData();
          formData.append('page_url', window.location.href);
          formData.append('page_name', document.querySelector('title').innerText.trim());
          formData.append('ask_year', form.querySelector('#dateInput').value);
          formData.append('ask_fio', form.querySelector('#fio').value.trim());
          formData.append('city_to_ask', form.querySelector('.ask-city-select .dropdown-head .head-text').dataset.cityid.trim());
          formData.append('ask_flowers', form.querySelector('#email').value.trim());
          formData.append('ask_question_message', form.querySelector('#ask').value.trim());
          formData.append('file', file !== undefined ? file : '');

          const q = await axios.post('/send_question', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              'X-CSRF-TOKEN': token,
            },
          });

          const { html, status } = q.data;
          if (status) {
            button.innerText = 'Отправлено';
            form.innerHTML = html;

            // отправляем событие в GTM
            if (window.dataLayer) {
              window.dataLayer.push({
                event: 'GoalEvent',
                eventCategoryUA: 'ask',
                eventActionUA: 'sendForm',
                eventGoalYM: 'ask_sendForm',
                eventGA4: 'ask_sendForm',
              });
            }
          } else {
            throw new Error();
          }
        } catch (err) {
          button.disabled = false;
          button.innerText = 'Ошибка. Попробуйте еще раз';
          if(err.response && err.response.data && err.response.data.message) {
            let errorDiv = button.previousElementSibling;
            if (!errorDiv || !errorDiv.classList.contains('error-form-data-message')) {
              errorDiv = document.createElement('div');
              errorDiv.className = 'error-form-data-message';
              button.parentNode.insertBefore(errorDiv, button);
            }
            errorDiv.innerHTML = err.response.data.message;
          }
        }
      }
    }

    button.addEventListener('click', sendFn);
  }
}
